import { Spin, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import AdminConsoleRunningJobList from "components/molecules/AdminConsoleRunningJobList";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Title } = Typography;

class AdminConsoleJobs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingJobs: false,
            busy: false,
            busyMessage: "Please wait...",
            refresh: false,
        };
    }

    componentWillMount() {
        this.props.getAllRunningJobs();
        if (!this.props.getAllRunningJobsResult || !this.props.getAllRunningJobsResult.Items || this.props.getAllRunningJobsResult.Items.length === 0) {
            this.setState({
                fetchingJobs: true,
            });
        } else {
            this.setState({
                refresh: true,
            });
        }
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.GetAllRunningJobsResultChanged(prevProps);
    }

    GetAllRunningJobsResultChanged = (prevProps) => {
        if (this.props.getAllRunningJobsResult && this.props.getAllRunningJobsResult !== prevProps.getAllRunningJobsResult) {
            if (!this.props.getAllRunningJobsResult.success) {
                showError("Unable to get running jobs at this moment.");
            }
            this.setState({
                fetchingJobs: false,
                refresh: false,
            });
        }
    };

    componentWillUnmount() {}

    isBusy = () => {
        return this.state.busy || this.state.fetchingJobs;
    };

    render() {
        return (
            <FlexContainerLayout
                header={
                    <>
                        <Title level={4} className="!mb-0">
                            Active Jobs Running Across Tenants
                        </Title>
                        {this.state.refresh ? <Spin size="small" /> : null}
                    </>
                }
                headerClassName="items-center gap-2"
            >
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.isBusy() ? <AdminConsoleRunningJobList jobList={this.props.allRunningJobsResult.Items}></AdminConsoleRunningJobList> : <></>}
            </FlexContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getAllRunningJobsResult: state.adminConsole.getAllRunningJobsResult,
        allRunningJobsResult: state.adminConsole.allRunningJobsResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllRunningJobs: () => dispatch(actions.getAllRunningJobsRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminConsoleJobs));
